import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController, AlertController, Platform } from '@ionic/angular';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { AjaxService } from 'src/app/services/ajax.service';
import { OpenlayerMapService } from 'src/app/services/openlayer-map.service';
import { WebsocketService } from 'src/app/services/websocket.service';
import { app, languageInitializer, serverUrl, storageVariable } from 'src/environments/environment';
import { AuthMapService } from 'src/app/services/auth-map.service';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/services/common.service';
import { PreventiveModelComponent } from '../preventive-model/preventive-model.component';
import { ActionModePage } from 'src/app/gridview-tab/action-mode/action-mode.page';

@Component({
  selector: 'app-vehicle-overview',
  templateUrl: './vehicle-overview.component.html',
  styleUrls: ['./vehicle-overview.component.scss'],
})
export class VehicleOverviewComponent implements OnInit {
  @Input() obj;
  modalpresent;
  vin: any;
  appSettings: any;
  traveVinData: any;
  liveTrackModel: any;
  segment = "LIVE_DATA";
  subSegment = "ENGINE";
  splitHeader: string[];
  @ViewChild('myGrid', { static: false }) myGrid: jqxGridComponent;
  @ViewChild('vehicleOverview', { static: false }) vehicleOverview;
  immobilizeStatus: boolean;
  watchStatus: boolean;
  immobResponse;
  pass: string = "";
  data: any;
  plateNo: any;
  liveTrackingChanges: any;
  renderer: (row: number, column: any, value: string) => string;
  source: { localdata: any; };
  tableData: any;
  dataAdapter: any;
  columns: { text: string; datafield: string; cellsrenderer: any; }[];
  nearbyVehDetArr: any = [];
  map: any;
  directory: string = languageInitializer.directory;
  Latitude: any;
  Longitude: any;
  liveDataGauge: any;
  selectedTab = "LIVE DATA";
  additionalGridData: any = {};
  busData: { busdataLabel: string; busdatavalue: string; }[];
  displayData: { head: string; label: { labelval: string; val: string; }[]; headSize: number; size: number; }[];
  inputVal: any = {
    "Current_hour_meter_Value": 0,
    "maintenanceValue": 0,
  };
  alarmData: [];
  entrypoint: any;
  platformVise = "7"
  layerModal = false;
  entryCheck = localStorage.entryPoint
  constructor(
    public websocketService: WebsocketService,
    private modalController: ModalController,
    private alertController: AlertController,
    private ajaxService: AjaxService,
    public mapService: AuthMapService,
    public trans: TranslateService,
    private commonService: CommonService,
    public platform: Platform
  ) {
    this.mapService = new OpenlayerMapService();
  }
  preventiveView() {
    this.modalpresent = true;
    console.log('clicked');
  }

  async openModal() {
    const modal = await this.modalController.create({
      component: PreventiveModelComponent,
      cssClass: this.directory != 'rtl' ? 'preventivemodal' : 'preventivemodal' + "-rtl",
    });
    return await modal.present();
  }

  async presentAlertPrompt() {
    const alert = await this.alertController.create({
      header: this.trans.instant('Enter Password!'),
      inputs: [
        {
          name: 'Password',
          type: 'password',
          placeholder: this.trans.instant('Password')
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            this.immobilizeStatus = !this.immobilizeStatus;
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Ok',
          handler: (data) => {
            if (document.getElementById("alert-input-6-0")["value"] === localStorage.password) {
              this.pass = document.getElementById("alert-input-6-0")["value"]
              this.conformPass();
            }
            else {
              this.immobilizeStatus = !this.immobilizeStatus;
              this.commonService.presentToast('Invalid password');
            }
            console.log('Confirm Ok');
          }
        }
      ]
    });
    await alert.present();

    let data: any = document.getElementsByClassName("alert-input-wrapper")[0]
    data.innerHTML = '<div class="alert-input-wrapper sc-ion-alert-md">' +
      '<input placeholder="Password" type="password" id="alert-input-6-0" tabindex="0" class="alert-input sc-ion-alert-md" autocomplete="off">' + '</div>'
  }


  conformPass() {
    let returnValue: string;
    if (this.immobilizeStatus == true) {
      returnValue = "immobilizeOn";
    } else {
      returnValue = "immobilizeOff";
    }
    const data = JSON.parse(localStorage.getItem('commandsData'));
    let command: any = this.commonService.commandsBasedOnModel(this.data.model, returnValue);
    // let command: any;
    // const data = JSON.parse(JSON.parse(localStorage.getItem('commandsData')));
    // for (let i = 0; i < data.length; i++) {
    //   if (data[i].hasOwnProperty(this.data.model)) {
    //     command = data[i][this.data.model][returnValue];
    //   }
    // }
    if (command != undefined) {
      const body = {
        "imeiNo": this.data.imeiNo,
        "manufacturer": this.data.make,
        "model": this.data.model,
        "command": command,
        "pass": this.pass
      }
      if (this.data.make == "deepseaNew")
        body["commandType"] = "slaveId";

      let url: string = serverUrl.Admin + "/api/device/command";

      this.commonService.presentLoader();
      this.ajaxService.ajaxPostWithString(url, body)
        .subscribe(resdata => {
          clearTimeout(this.immobResponse);
          console.log('----------Recieved Command From Device ==>' + resdata + '<==----------');
          if (this.data.model == "TK003") {
            statusBitImmobilize = 0;
            if (this.immobilizeStatus == true) {
              statusBitImmobilize = 1;
            }
            this.data["lockstatus"] = statusBitImmobilize;
            localStorage.setItem("selectedVin", JSON.stringify(this.data));
            let tempDashboardData = localStorage.dashboardData;
            this.commonService.presentToast("Status of immobilize changed")
          } else {
            var statusBitImmobilize;
            const immobilizeSuccess = this.commonService.commandsBasedOnModel(this.data.model, 'immobilizeSuccess');
            if (resdata === undefined || resdata === 'null' || resdata === null || resdata === '' || resdata === 'noresponse') {
              this.commonService.presentAlert('Error', 'Empty response from device. Please try after sometime');
              this.immobilizeStatus = !this.immobilizeStatus;
            } else {
              let checkData = '';
              for (let i = 0; i < immobilizeSuccess.length; i++) {
                checkData = resdata.indexOf(immobilizeSuccess[i]);
                if ((checkData.toString()) !== '-1') {
                  break;
                }
              }
              if ((checkData.toString()) === '-1') {
                this.commonService.presentAlert('Error', 'Invalid response. Please try after sometime.');
                this.immobilizeStatus = !this.immobilizeStatus;
              } else {
                statusBitImmobilize = 0;
                if (this.immobilizeStatus == true) {
                  statusBitImmobilize = 1;
                }
                this.data["lockstatus"] = statusBitImmobilize;
                localStorage.setItem("selectedVin", JSON.stringify(this.data));
                let tempDashboardData = localStorage.dashboardData;
              }
            }
          }
          this.commonService.dismissLoader();
          this.getBack();
        });
      this.immobResponse = setTimeout(() => {
        this.commonService.dismissLoader();
        this.commonService.presentAlert('No Reply', 'Please try after sometime.');
        this.immobilizeStatus = !this.immobilizeStatus;
      }, 60000);
    } else {
      this.immobilizeStatus = !this.immobilizeStatus;
      this.commonService.presentAlert('Alert', this.data.model + " doesn't have immobilize option");
    }
  }

  getBack() {
    this.modalController.dismiss();
  }


  createMap() {
    if (this.vehicleOverview) {
      this.map = this.mapService.loadMap(this.vehicleOverview.nativeElement, { lat: -25.344, lng: 131.036 }, false, false);
      this.mapService.setCenter(this.map, { lat: 17.786351, lng: 78.090820 });
      const latLng = { lat: this.traveVinData.latitude, lng: this.traveVinData.longitude };
      this.mapService.addMarker(this.map, latLng, 'nearBy', 'assets/vtstrackhisIcon/Idle.png');
    }
  }
  switchMap() {
    this.layerModal = !this.layerModal
    this.map.getLayers().item(3).setVisible(this.layerModal);
    this.map.getLayers().item(0).setVisible(!this.layerModal);
  }

  changeToArabic(text: any) {
    return this.commonService.numberToArabic(text.toString());
  }


  wsResponse(res) {
    // console.log("res veh-over",res);
    if (Array.isArray(res.alerts) && res.alerts.length !== 0 && app.entryPoint == "ATM") {
      console.log("res grid", res.alerts[0].vid.alerttype)
      if (res.alerts[0].vid.alerttype == "POWERCUT" || res.alerts[0].vid.alerttype == "MOVEMENT") {
        this.commonService.playAudio();
      }
    } else {
      if (Array.isArray(res.alerts) && res.alerts.length !== 0)
        if (res.alerts[0].vid.alerttype == "SOS") {
          this.commonService.playAudio();
        }
    }

    var data = res.liveDatas
    if (data) {
      if (data[this.vin] != undefined) {
        this.liveTrackModel = this.getLiveTrackIcon(this.commonService.color[res["liveDatas"][this.vin].status], this.commonService.vehicleModelmap[res["liveDatas"][this.vin].icon], res["liveDatas"][this.vin].plateNo);
        res["liveDatas"][this.vin]["odometer"] = parseInt(res["liveDatas"][this.vin]["odometer"]) / 1000;
        this.traveVinData = res["liveDatas"][this.vin];
        this.liveTrackingChanges = res;
        if (this.additionalGridData[this.traveVinData.icon] != undefined &&
          this.additionalGridData[this.traveVinData.icon]['popup'] == 'gauge')
          this.updateDeepSeaJson();
      }
    }
  }
  myGridOnRowSelect(data) {
    if (data.args.row) {
      const latLng = { lat: data.args.row.latitude, lng: data.args.row.longitude };
      this.mapService.addMarker(this.map, latLng, data.args.row.vin, data.args.row.icon);
      this.mapService.fitBounds(this.map, 1)
    } else {
      if (data.args.rowindex == 0) {
        for (let i = 0; i < this.nearbyVehDetArr.length; i++) {
          this.mapService.removeMarkersById(this.map, this.nearbyVehDetArr[i].vin)
        }
      } else {
        for (let i = 0; i < this.nearbyVehDetArr.length; i++) {
          const latLng = { lat: this.nearbyVehDetArr[i].latitude, lng: this.nearbyVehDetArr[i].longitude };
          this.mapService.addMarker(this.map, latLng, this.nearbyVehDetArr[i].vin, this.nearbyVehDetArr[i].icon);
        }
      }
      this.mapService.fitBounds(this.map, 1)
    }
  }

  getModalData() {
    if (this.additionalGridData[(this.traveVinData.icon).toUpperCase()])
      if (this.additionalGridData[(this.traveVinData.icon).toUpperCase()]['popup'] == 'employee')
        return true;
    return false;
  }

  getShiftDetails(shift, split) {
    let shDetails = ""
    if (!shift)
      return "---"
    for (let i = 0; i < shift.split(split).length; i++) {
      if (shift.split(split)[i]) {
        shDetails += shift.split(split)[i].split("#")[1];
        if (i != shift.split(split).length - 1)
          shDetails += ", "
      }
    }
    return shDetails;
  }

  myGridOnRowUnselect(data) {
    if (data.args.row) {
      this.mapService.removeMarkersById(this.map, data.args.row.vin)
    } else {
      for (let i = 0; i < this.nearbyVehDetArr.length; i++) {
        this.mapService.removeMarkersById(this.map, this.nearbyVehDetArr[i].vin)
      }
      this.mapService.fitBounds(this.map, 1)
    }
  }

  nearByList() {
    let liveDatas: any = Object.values(storageVariable.upDatedJsonData.liveDatas);
    let vehicleIcon;

    for (let i = 0; i < liveDatas.length; i++) {
      if (this.traveVinData.vin == liveDatas[i].vin)
        continue;
      const radlat1 = Math.PI * this.traveVinData.latitude / 180;
      const radlat2 = Math.PI * liveDatas[i].latitude / 180;
      const theta = this.traveVinData.longitude - liveDatas[i].longitude;
      const radtheta = Math.PI * theta / 180;
      const latlng = { lat: liveDatas[i].latitude, lng: liveDatas[i].longitude };
      let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1)
        * Math.cos(radlat2) * Math.cos(radtheta);
      dist = Math.acos(dist);
      dist = dist * 180 / Math.PI;
      dist = dist * 60 * 1.1515;
      dist = dist * 1.609344;
      dist = Math.ceil(dist);

      vehicleIcon = this.getLiveTrackIcon(this.commonService.color[liveDatas[i].status], this.commonService.vehicleModelmap[liveDatas[i].icon], liveDatas[i].plateNo)

      this.nearbyVehDetArr.push({
        vin: liveDatas[i].vin,
        plateno: liveDatas[i].plateNo,
        //distance:dist,
        distance: this.commonService.numberToArabic(dist.toString()),
        //status: liveDatas[i].status,
        status: liveDatas[i].status == null ? this.trans.instant("Yet_to_transmission") : this.trans.instant(liveDatas[i].status),
        latitude: liveDatas[i].latitude,
        longitude: liveDatas[i].longitude,
        latLng: latlng,
        icon: vehicleIcon,
        assert: liveDatas[i].icon
      });

    }
    this.renderer = (row: number, column: any, value: string,) => {
      if (column == "plateno" && value.split("@,@")[1]) {
        return '<span  style="line-height:22px;font-size:11px;color:darkblue;margin:auto;padding:0px 5px">' + value.split("@,@")[0] + " (" + value.split("@,@")[1] + ')</span>';
      } if (value == "" || null || undefined) {
        // return "----No Data----"
        return this.trans.instant("----No Data----")
      }
      else {
        return '<span  style="line-height:22px;font-size:11px;color:darkblue;margin:auto;padding:0px 5px">' + value + '</span>';
      }
    }
    this.source = { localdata: this.nearbyVehDetArr };
    this.dataAdapter = new jqx.dataAdapter(this.source);
    let display;
    if (app.entryPoint == "WFT") {
      display = { text: this.trans.instant('Employee Name'), datafield: 'plateno', cellsrenderer: this.renderer }
    } else {
      if (this.hidebms) {
        display = { text: this.trans.instant('Battery Name'), datafield: 'plateno', cellsrenderer: this.renderer }
      } else {
        display = { text: this.trans.instant('Plate No'), datafield: 'plateno', cellsrenderer: this.renderer }
      }
    }
    this.columns = [
      display,
      { text: this.trans.instant('Status'), datafield: 'status', cellsrenderer: this.renderer },
      ...(
        this.hidebms
          ? []
          : [{ text: this.trans.instant('Km'), datafield: 'distance', cellsrenderer: this.renderer }]
      )
    ];

  }

  closeModel() {
    this.modalController.dismiss()
  }
  showLocation(data) {
    // dt.location = "bhdsh"
    const url = serverUrl.web + "/login/company/latlngtoaddress/" + data.latitude + "/" + data.longitude + "/" + localStorage.corpId + "/" + localStorage.lang;
    this.ajaxService.ajaxGetObject(url)
      .subscribe(res => {
        if (JSON.stringify(res) == "{}") {
          data.location = data.latitude + ',' + data.longitude;
        } else {
          data.location = res;
        }

      });
  }

  navigateToGoogle() {
    const latlng = this.traveVinData
    window.open("http://www.google.com/maps/place/" + latlng.latitude + "," + latlng.longitude)
    // window.open('geo://'+this.selectedVin.latitude+', '+this.selectedVin.longitude+'system');
  }

  getLiveTrackIcon = (color, path, plateNo) => {
    if (path == undefined || path == null) {
      path = this.commonService.vehicleModelmap["CAR"]
    }
    let svg1 = '   <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="24.714mm" height="15.481mm" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"  ' +
      '   viewBox="0 0 2471.4 1548.1"  ' +
      '    xmlns:xlink="http://www.w3.org/1999/xlink">  ' +
      '     <path fill="' + color + '"  d="' + path + '"/>  ' +
      '     <path fill="' + color + '"  d="M47.78 0.01l2375.87 0c26.38,0.02 47.76,27.23 47.76,60.82l0 493.09c0,33.57 -21.38,60.78 -47.76,60.78l-2375.87 0.02c-26.39,-0.02 -47.76,-27.23 -47.76,-60.82l-0.03 -493.09c0.03,-33.57 21.4,-60.78 47.79,-60.78l0 -0.02z"/>  ' +
      '     <g transform="matrix(0.999986 0 0 0.999986 9.42214 -382.593)">  ' +
      '      <text style="font-weight:bold;font-size:300px;font-family:\'Arial\'" x="133.12" y="774.05" fill="white" >' + plateNo + '</text>  ' +
      '     </g>  ' +
      '   </svg>  '
    if (app.entryPoint == "WFT")
      svg1 = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" width="1in" height="1in" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" viewBox="0 0 600 700">
    <path fill="` + color + `"  d="M194.92 217.82c1.45,-0.48 2.76,-0.67 3.41,0.78l0.09 -30.69c-7.61,-1.43 -15.56,5.63 -18.05,9.18 -5.11,7.25 -4.16,13.81 -4.16,23.52 0,18.56 0.02,37.12 0,55.67 0,3.89 -0.65,9.38 1.12,12.53 1.53,2.74 4.73,5.36 9.46,4.71 9.22,-1.28 7.71,-11.78 7.7,-20.31 -0.01,-8.59 -0.97,-50.74 0.43,-55.39zm43.51 217.49l-11.76 11.76 -11.76 -11.76c-31.07,-5.55 -54.67,-32.72 -54.67,-65.39 0,-1.8 0.07,-3.57 0.21,-5.33 2.72,34.19 31.39,62.79 66.28,62.79 34.89,0 63.43,-28.59 66.15,-62.78 0.14,1.76 0.21,3.54 0.21,5.33 0,32.67 -23.59,59.84 -54.67,65.39zm38.7 -172.38c-0.19,-16.11 -0.02,-32.33 -0.02,-48.47 0.01,-10.87 -2.5,-19.58 -12.41,-24.43 -2.57,-1.26 -6.57,-2.72 -9.78,-2.12l0.01 30.7c0.95,-1.5 2.05,-1.26 3.5,-0.84 1.99,6.38 -0.67,64.22 0.81,69.31 2.36,8.15 13.2,8.72 16.93,1.44 1.65,-3.24 0.87,-9.39 0.96,-13.42l-0.03 -1.36 0.04 -8.91 -0.02 -1.91zm-75.9 11.6l0 9.64 -1.31 0.5c-1,0.3 -0.2,-0.19 -1.42,0.37 -0.46,10.93 -0.05,22.73 -0.05,33.76l0 68.39c0,7.82 -2.13,21.44 10.37,23.97 5.8,1.18 9.61,-1.18 12.39,-4.02 3.8,-3.89 3.49,-7.55 3.48,-13.83l0 -93.81c0,-2.5 -0.7,-6.44 1.98,-6.43 2.62,0 2,3.56 1.98,5.99l0.02 93.82c0,5.95 -0.44,10.18 3.26,14.04 7.85,8.18 18.5,4.22 21.82,-3.19 1.82,-4.08 1.15,-11.26 1.15,-16.11 0,-11.4 0,-22.8 0,-34.2 0,-22.4 0.77,-46.17 -0.05,-68.39l-2.73 -0.88 -0.03 -10.09 0.05 -86.38 -6.13 0 0.01 62.19 -15.12 -0.74c-0.29,-6.26 -0.04,-12.98 -0.04,-19.17 0,-11.46 7.16,-32.1 12.3,-42.09l-33.02 -0.2c3.5,13.05 10.23,29.82 10.23,42.55 0,6.34 0.25,13.22 -0.04,19.49l-12.85 0.15 -0.13 -62.15 -6.09 -0.06 -0.02 86.85zm19.63 -138.63c-2.69,2.15 -2.97,-2.43 -3.3,-4.39 -0.39,-2.33 -0.83,-5.77 -1.44,-7.68 -7.01,3.63 -11.76,10.41 -12.63,20.93 -1.79,0.91 -3.93,0.65 -4.18,3.52 -0.25,2.9 1.44,3.88 4.11,3.88l46.48 0.01c2.55,-0.01 4.11,-0.83 4.12,-3.47 0.02,-3.4 -2.24,-2.97 -4.22,-3.95 -0.89,-10.65 -5.65,-17.23 -12.62,-20.94 -1.53,4.83 -1.16,15.24 -4.71,12.08 -1.96,-1.93 1.53,-11.45 1.16,-14.82 -1.31,-2.5 -6.43,-1.91 -9.17,-1.91 -10.63,0 0,13.17 -3.61,16.72zm26.56 20.99l-41.52 -0.14c-1.71,12.18 9.53,22.29 20.76,22.29 11.22,0 22.47,-10.18 20.76,-22.15z" x="12" style="&#10;    x: 23;&#10;"/>
     <rect fill="` + color + `" x="-19" y="12" width="600" height="97.94"/>
     <text style="font-weight:bold;font-size:69.44px;font-family:'Arial'" x="101.87" y="79.42" fill="white">`+ plateNo + `</text>
 </svg>`
    const src = 'data:image/svg+xml;charset=utf-8,'
      + encodeURIComponent(svg1);
    return src;
  }

  wsOnError() {
  }

  livetrackWeb($event) {

  }

  changeTab(head) {
    this.selectedTab = head;
    if (head == 'NEARBY') {
      if (this.vehicleOverview)
        this.createMap()
      else
        setTimeout(() => this.createMap(), 300)
    }
  }

  updateDeepSeaJson = () => {
    this.liveDataGauge = {
      "RPM": {
        minor: { interval: 1, size: '5%' },
        major: {
          interval: 3, size: '9%'
        },
        count: (Number(this.traveVinData.engineSpeed) / 100),
        end: [9, 21, 30],
        label: { interval: 3, position: 'outside' },
        caption: { value: (Number(this.traveVinData.engineSpeed) / 100) + " RPM", position: 'bottom', offset: [0, 10], visible: true }
      },
      "OIL_PRESSURE": {
        minor: { interval: 2, size: '5%' },
        major: { interval: 6, size: '9%' },
        count: Number(this.traveVinData.oilPressure) / 100,
        end: [9, 21, 30],
        label: { interval: 6, position: 'inside' },
        caption: { value: Number(this.traveVinData.oilPressure) / 100 + " BARS", position: 'bottom', offset: [0, 10], visible: true }
      },
      "COOLANT_TEMP": {
        minor: { interval: 7, size: '5%' },
        major: { interval: 14, size: '9%' },
        count: Number(this.traveVinData.coolandTemperature),
        end: [42, 105, 140],
        label: { interval: 28, position: 'inside' },
        caption: { value: Number(this.traveVinData.coolandTemperature) + " C", position: 'bottom', offset: [0, 10], visible: true }
      },
      "FUEL_LEVEL": {
        minor: { interval: 5, size: '5%' },
        major: { interval: 20, size: '9%' },
        count: Number(this.traveVinData.fuelLeval),
        end: [40, 70, 100],
        label: { interval: 20, position: 'inside' },
        caption: { value: Number(this.traveVinData.fuelLeval) + " %", position: 'bottom', offset: [0, 10], visible: true }
      },
      "BAT_VOLTAGE": {
        minor: { interval: 3, size: '5%' },
        major: { interval: 6, size: '9%' },
        count: Number(this.traveVinData.batteryVoltageData),
        end: [12, 21, 30],
        label: { interval: 6, position: 'inside' },
        caption: { value: Number(this.traveVinData.batteryVoltageData) + " V", position: 'bottom', offset: [0, 10], visible: true }
      },
      "ALT_CHARGING": {
        minor: { interval: 3, size: '5%' },
        major: { interval: 6, size: '9%' },
        count: Number(this.traveVinData.chargeAlternatorVoltage),
        end: [12, 21, 30],
        label: { interval: 6, position: 'inside' },
        caption: { value: Number(this.traveVinData.chargeAlternatorVoltage) + " V", position: 'bottom', offset: [0, 10], visible: true }
      },
      "L1": {
        minor: { interval: 25, size: '5%' },
        major: { interval: 100, size: '9%' },
        count: Number(this.traveVinData.genL1_N_V),
        end: [200, 400, 600],
        label: { interval: 100, position: 'inside' },
        caption: { value: Number(this.traveVinData.genL1_N_V) + " V", position: 'bottom', offset: [0, 10], visible: true }
      },
      "L2": {
        minor: { interval: 25, size: '5%' },
        major: { interval: 100, size: '9%' },
        count: Number(this.traveVinData.genL2_N_V),
        end: [200, 400, 600],
        label: { interval: 100, position: 'inside' },
        caption: { value: Number(this.traveVinData.genL2_N_V) + " V", position: 'bottom', offset: [0, 10], visible: true }
      },
      "L3": {
        minor: { interval: 25, size: '5%' },
        major: { interval: 100, size: '9%' },
        count: Number(this.traveVinData.genL3_N_V),
        end: [200, 400, 600],
        label: { interval: 100, position: 'inside' },
        caption: { value: Number(this.traveVinData.genL3_N_V) + " V", position: 'bottom', offset: [0, 10], visible: true }
      },
      "GEN": {
        minor: { interval: 5, size: '5%' },
        major: { interval: 10, size: '9%' },
        count: Number(this.traveVinData.generatorFrequency),
        end: [20, 55, 80],
        label: { interval: 10, position: 'inside' },
        caption: { value: Number(this.traveVinData.generatorFrequency) + " HZ", position: 'bottom', offset: [0, 10], visible: true }
      }
    }


    let parsedSubjectData = JSON.parse(this.traveVinData.subject)
    this.displayData = [
      {
        'head': "VOLT",
        'label': [
          {
            'labelval': 'L1-L2',
            'val': this.traveVinData.subject.includes("genL1_L2_V") == true ? parsedSubjectData["genL1_L2_V"] : 0
          },
          {
            'labelval': 'L2-L3',
            'val': this.traveVinData.subject.includes("genL2_L3_V") == true ? parsedSubjectData["genL2_L3_V"] : 0
          },
          {
            'labelval': 'L3-L1',
            'val': this.traveVinData.subject.includes("genL3_L1_V") == true ? parsedSubjectData["genL3_L1_V"] : 0
          }
        ],
        'headSize': 1.2
        ,
        'size': 6
      },
      {
        'head': "VOLT",
        'label': [
          {
            'labelval': 'L1',
            'val': this.traveVinData.subject.includes("genL1_N_V") == true ? parsedSubjectData["genL1_N_V"] : 0
          },
          {
            'labelval': 'L2',
            'val': this.traveVinData.subject.includes("genL2_N_V") == true ? parsedSubjectData["genL2_N_V"] : 0
          },
          {
            'labelval': 'L3',
            'val': this.traveVinData.subject.includes("genL3_N_V") == true ? parsedSubjectData["genL3_N_V"] : 0
          }
        ],
        'headSize': 1.2
        ,
        'size': 6
      },
      {
        'head': "AMP",
        'label': [
          {
            'labelval': 'L1',
            'val': this.traveVinData.subject.includes("genL1C") == true ? parsedSubjectData["genL1C"] : 0
          },
          {
            'labelval': 'L2',
            'val': this.traveVinData.subject.includes("genL2C") == true ? parsedSubjectData["genL2C"] : 0
          },
          {
            'labelval': 'L3',
            'val': this.traveVinData.subject.includes("genL3C") == true ? parsedSubjectData["genL3C"] : 0
          }
        ],
        'headSize': 1.2
        ,
        'size': 8
      },
      {
        'head': "KW",
        'label': [
          {
            'labelval': 'L1',
            'val': this.traveVinData.subject.includes("genL1W") == true ? parsedSubjectData["genL1W"] : 0
          },
          {
            'labelval': 'L2',
            'val': this.traveVinData.subject.includes("genL2W") == true ? parsedSubjectData["genL2W"] : 0
          },
          {
            'labelval': 'L3',
            'val': this.traveVinData.subject.includes("genL3W") == true ? parsedSubjectData["genL3W"] : 0
          }
        ],
        'headSize': 1.2
        ,
        'size': 6
      },
      {
        'head': "KVA",
        'label': [
          {
            'labelval': 'L1',
            'val': this.traveVinData.subject.includes("genL1VA") == true ? parsedSubjectData["genL1VA"] : 0
          },
          {
            'labelval': 'L2',
            'val': this.traveVinData.subject.includes("genL2VA") == true ? parsedSubjectData["genL2VA"] : 0
          },
          {
            'labelval': 'L3',
            'val': this.traveVinData.subject.includes("genL3VA") == true ? parsedSubjectData["genL3VA"] : 0
          }
        ],
        'headSize': 1.2,
        'size': 6
      },
      {
        'head': "KVAR",
        'label': [
          {
            'labelval': 'L1',
            'val': this.traveVinData.subject.includes("genL1VAr") == true ? parsedSubjectData["genL1VAr"] : 0
          },
          {
            'labelval': 'L2',
            'val': this.traveVinData.subject.includes("genL2VAr") == true ? parsedSubjectData["genL2VAr"] : 0
          },
          {
            'labelval': 'L3',
            'val': this.traveVinData.subject.includes("genL3VAr") == true ? parsedSubjectData["genL3VAr"] : 0
          }
        ],
        'headSize': 1.2
        ,
        'size': 6
      },
      {
        'head': "PF",
        'label': [
          {
            'labelval': 'L1',
            'val': this.traveVinData.subject.includes("genPFL1") == true ? parsedSubjectData["genPFL1"] : 0
          },
          {
            'labelval': 'L2',
            'val': this.traveVinData.subject.includes("genPFL2") == true ? parsedSubjectData["genPFL2"] : 0
          },
          {
            'labelval': 'L3',
            'val': this.traveVinData.subject.includes("genPFL3") == true ? parsedSubjectData["genPFL3"] : 0
          }
        ],
        'headSize': 1.2
        ,
        'size': 6
      },
      {
        'head': "ACCUMULATED",
        'label': [
          {
            'labelval': 'KWH',
            'val': this.traveVinData.subject.includes("genNegativeKWH") == true ? parsedSubjectData["genNegativeKWH"] : 0
          },
          {
            'labelval': 'KVAH',
            'val': this.traveVinData.subject.includes("genKVAH") == true ? parsedSubjectData["genKVAH"] : 0
          },
          {
            'labelval': 'KVArH',
            'val': this.traveVinData.subject.includes("genKVArH") == true ? parsedSubjectData["genKVArH"] : 0
          }
        ],
        'headSize': 1.4
        ,
        'size': 6
      },
      {
        'head': "TOTAL",
        'label': [
          {
            'labelval': 'KW',
            'val': this.traveVinData.subject.includes("gen_tot_W") == true ? parsedSubjectData["gen_tot_W"] : 0
          },
          {
            'labelval': 'KWA',
            'val': this.traveVinData.subject.includes("gentotVA") == true ? parsedSubjectData["gentotVA"] : 0
          },
          {
            'labelval': 'KWAr',
            'val': this.traveVinData.subject.includes("gentotVAr") == true ? parsedSubjectData["gentotVAr"] : 0
          }
        ],
        'headSize': 1.2
        ,
        'size': 6
      }
    ];

    this.busData = [
      {
        busdataLabel: "Bus Frequency",
        busdatavalue: this.traveVinData.subject.includes("busFrequency") == true ? parsedSubjectData.busFrequency : 0
      },
      {
        busdataLabel: "Bus L1-N Voltage",
        busdatavalue: this.traveVinData.subject.includes("busL1_N_V") == true ? parsedSubjectData.busL1_N_V : 0
      },
      {
        busdataLabel: "Bus L2-N Voltage",
        busdatavalue: this.traveVinData.subject.includes("busL2_N_V") == true ? parsedSubjectData.busL2_N_V : 0
      },
      {
        busdataLabel: "Bus L3-N Voltage",
        busdatavalue: this.traveVinData.subject.includes("busL3_N_V") == true ? parsedSubjectData.busL3_N_V : 0
      },
      {
        busdataLabel: "Bus L1-L2 Voltage",
        busdatavalue: this.traveVinData.subject.includes("busL1L2_N_V") == true ? parsedSubjectData.busL1L2_N_V : 0
      },
      {
        busdataLabel: "Bus L2-L3 Voltage",
        busdatavalue: this.traveVinData.subject.includes("busL2L3_N_V") == true ? parsedSubjectData.busL2L3_N_V : 0
      },
      {
        busdataLabel: "Bus L3-L1 Voltage",
        busdatavalue: this.traveVinData.subject.includes("busL3L1_N_V") == true ? parsedSubjectData.busL3L1_N_V : 0
      }
    ];

    this.alarmData = this.traveVinData.subject.includes("alarm") == true ? parsedSubjectData.alarm.split(",") : ""

    this.gethourmeterAndMaintenanceValue();
  }


  // conformPass() {
  //   throw new Error('Method not implemented.');
  // }
  gethourmeterAndMaintenanceValue() {
    if (this.traveVinData.engineRunTime)
      this.inputVal.Current_hour_meter_Value = (this.traveVinData.engineRunTime != undefined ? (((parseInt(this.traveVinData.engineRunTime
      ) / 60) / 60).toFixed(0).toString()
        + ':' + Number(("0" + ((parseInt(this.traveVinData.engineRunTime) / 60) % 60)).slice(-2))) : 0);
    else {
      let sec: any = parseInt(this.traveVinData.totalRuntime) * 60;
      let hours: any = Math.floor(sec / 3600);
      (hours >= 1) ? sec = sec - (hours * 3600) : hours = '00';
      let min: any = Math.floor(sec / 60);
      (min >= 1) ? sec = sec - (min * 60)
        : min = '00';
      (sec < 1) ? sec = '00' : void 0;
      (min.toString().length == 1) ? min = '0'
        + min : void 0;
      (sec.toString().length == 1) ? sec = '0'
        + sec : void 0;
      this.inputVal.Current_hour_meter_Value = hours + ':' + min;
    }
    this.inputVal.maintenanceValue = this.traveVinData.preventiveMaintenance != null ? ((parseInt(this.traveVinData.preventiveMaintenance) / 60).toFixed(0)
      + ':' + Number(("0" + (parseInt(this.traveVinData.preventiveMaintenance) % 60)).slice(-2))) : "0";
  }

  getAddress(lat, lng) {
    const url = serverUrl.web + "/login/company/latlngtoaddress/" + lat + "/" + lng + "/" + localStorage.corpId + "/" + localStorage.lang;
    this.ajaxService.ajaxGetObject(url)
      .subscribe(res => {
        this.data.location = res;
      });
  }

  splitNameArabic(name) {
    return this.commonService.splitNameArabic(name, this.directory)
  }
  hidebms: boolean = false;

  ngOnInit() {
    if (this.commonService.BatteryLogin == true)
      this.hidebms = true;
    this.platformVise = '7';



    this.data = JSON.parse(localStorage.selectedVin);
    this.entrypoint = app.entryPoint;
    this.splitHeader = ['LIVE DATA', 'NEARBY']
    this.vin = JSON.parse(localStorage.selectedVin).vin
    this.appSettings = JSON.parse(localStorage.appSettings);
    this.traveVinData = JSON.parse(localStorage.selectedVin)
    this.websocketService.setProductService(this);
    this.additionalGridData = JSON.parse(JSON.parse(localStorage.getItem('loginData'))[1].mvtmapmodelpopup);
    this.nearByList();

    this.commonService.updateLanguageDir
      .subscribe(res => {
        this.directory = res == "" ? this.directory : res
      })

    const credentials = {
      dashboardVin: this.vin,
      defaultInterval: this.appSettings.liveTrackingDelay,
      make: this.traveVinData.make,
      model: this.traveVinData.model,
      delay: this.appSettings.liveTrackingDelay,
      ImeiNo: this.traveVinData.imeiNo,
      entryPoint: app.entryPoint,
      Check: false,
      emailId: localStorage.userName,
      branchID: localStorage.corpId,
      companyID: localStorage.corpId,
      mode: 'liveTrackConnect'
    };
    this.websocketService.reSendRequest(credentials);
    setTimeout(res => {
      this.createMap()
    }, 1000)
    this.Latitude = this.commonService.numberToArabic((this.traveVinData.latitude).toString());
    this.Longitude = this.commonService.numberToArabic((this.traveVinData.longitude).toString());
    if (this.additionalGridData[this.traveVinData.icon] != undefined &&
      this.additionalGridData[this.traveVinData.icon]['popup'] == 'gauge')
      this.updateDeepSeaJson();
    if (this.additionalGridData[this.traveVinData.icon] != undefined &&
      this.additionalGridData[this.traveVinData.icon]['popup'] == 'simple')
      this.gethourmeterAndMaintenanceValue();
    this.additionalGridData = JSON.parse(JSON.parse(localStorage.getItem('loginData'))[1].mvtmapmodelpopup);



    // let dashboardData = storageVariable.dashboardData.liveDatas;
    // this.liveDataGauge.RPM.caption.value = Number(JSON.parse(dashboardData[this.vin].engineSpeed)) / 100 + " RPM"
    // this.liveDataGauge.RPM.count = Number(JSON.parse(dashboardData[this.vin].engineSpeed)) / 100;
    // this.liveDataGauge.OIL_PRESSURE.caption.value = Number(JSON.parse(dashboardData[this.vin].oilPressure)) / 100; + " BARS"
    // this.liveDataGauge.OIL_PRESSURE.count = Number(JSON.parse(dashboardData[this.vin].oilPressure)) / 100;
    // this.liveDataGauge.COOLANT_TEMP.caption.value = Number(JSON.parse(dashboardData[this.vin].coolandTemperature)) + " C"
    // this.liveDataGauge.COOLANT_TEMP.count = Number(JSON.parse(dashboardData[this.vin].coolandTemperature));
    // this.liveDataGauge.FUEL_LEVEL.caption.value = Number(JSON.parse(dashboardData[this.vin].fuelLeval)) + " %"
    // this.liveDataGauge.FUEL_LEVEL.count = Number(JSON.parse(dashboardData[this.vin].fuelLeval));
    // this.liveDataGauge.BAT_VOLTAGE.caption.value = Number(JSON.parse(dashboardData[this.vin].batteryVoltage)) + " V"
    // this.liveDataGauge.BAT_VOLTAGE.count = Number(JSON.parse(dashboardData[this.vin].batteryVoltage));
    // this.liveDataGauge.ALT_CHARGING.caption.value = Number(JSON.parse(dashboardData[this.vin].chargeAlternatorVoltage)); + " V"
    // this.liveDataGauge.ALT_CHARGING.count = Number(JSON.parse(dashboardData[this.vin].chargeAlternatorVoltage));
    // this.liveDataGauge.GEN.caption.value = Number(JSON.parse(dashboardData[this.vin].generatorFrequency)); + " Hz"
    // this.liveDataGauge.GEN.count = Number(JSON.parse(dashboardData[this.vin].generatorFrequency));
    // this.liveDataGauge.L1.caption.value = Number(JSON.parse(dashboardData[this.vin].genL1_N_V)); + " V"
    // this.liveDataGauge.L1.count = Number(JSON.parse(dashboardData[this.vin].genL1_N_V));
    // this.liveDataGauge.L2.caption.value = Number(JSON.parse(dashboardData[this.vin].genL2_N_V)) + " V"
    // this.liveDataGauge.L2.count = Number(JSON.parse(dashboardData[this.vin].genL2_N_V))
    // this.liveDataGauge.L3.caption.value = Number(JSON.parse(dashboardData[this.vin].genL3_N_V)) + " V"
    // this.liveDataGauge.L3.count = Number(JSON.parse(dashboardData[this.vin].genL3_N_V))
    // this.inputVal.Current_hour_meter_Value = dashboardData[this.vin].mileageInit
    // this.inputVal.maintenanceValue = dashboardData[this.vin].preventivedue
    // this.inputVal.plateno = dashboardData[this.vin].plateNo
    // this.inputVal.lastTransmissionTime = dashboardData[this.vin].timeStamp
    // this.inputVal.liveTrackAddressgen = dashboardData[this.vin].latitude + ',' + dashboardData[this.vin].longitude;

  }


}


